import React from 'react'
import LegalPage from '../comps/legalPage'

const AboutUs = () => (
  <LegalPage
    title="About Pinweelo"
    heading="About us"
    description="Learn what Pinweelo is, who it is for, and how we help people discover and share video."
  >
    <div className="legalHeroShot legalRise">
      <img
        alt="People watching and sharing video together"
        src="https://images.pexels.com/photos/3184433/pexels-photo-3184433.jpeg?auto=compress&cs=tinysrgb&w=1600"
      />
      <div>
        <h2>About us</h2>
        <p>
          Pinweelo is a place to watch, post, and share videos, photos, and rooms — built for first-time posters and people who already live online.
        </p>
      </div>
    </div>

    <article className="legalSplit legalRise">
      <img alt="Creator filming a video" src="https://images.pexels.com/photos/3379942/pexels-photo-3379942.jpeg?auto=compress&cs=tinysrgb&w=1200" />
      <div>
        <h3>What Pinweelo is</h3>
        <p>
          Pinweelo is a social video site. You can watch shorts and longer videos, post photos, chat with people you follow, and join live rooms. The feed is dark, fast, and meant to stay out of the way of the content.
        </p>
      </div>
    </article>

    <article className="legalSplit legalSplitFlip legalRise">
      <img alt="Friends using phones together" src="https://images.pexels.com/photos/607812/pexels-photo-607812.jpeg?auto=compress&cs=tinysrgb&w=1200" />
      <div>
        <h3>Who it is for</h3>
        <p>
          If you are new to posting, Pinweelo keeps the steps simple: make an account, add a photo, and share. If you already know social apps, you get playlists, rooms, comments, and a creator cash-out path without a noisy layout.
        </p>
      </div>
    </article>

    <article className="legalSplit legalRise">
      <img alt="People talking in a studio" src="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1200" />
      <div>
        <h3>What we care about</h3>
        <p>
          Accurate posts, a community that can talk about ideas, and tools that help you stay consistent. We want people to find work they like and share it with others who care about the same things.
        </p>
      </div>
    </article>

    <div className="legalGallery legalRise">
      <img alt="Watching a film" src="https://images.pexels.com/photos/799443/pexels-photo-799443.jpeg?auto=compress&cs=tinysrgb&w=900" />
      <img alt="Camera and lights" src="https://images.pexels.com/photos/3062541/pexels-photo-3062541.jpeg?auto=compress&cs=tinysrgb&w=900" />
      <img alt="Editing on a laptop" src="https://images.pexels.com/photos/1181244/pexels-photo-1181244.jpeg?auto=compress&cs=tinysrgb&w=900" />
    </div>
  </LegalPage>
)

export default AboutUs
